import React from "react";
import SbEditable from "storyblok-react";
import Stat from "./Stat";
import Button from "src/components/Button";
import Heading from "src/components/Heading";

const SimpleOnBrand = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="relative bg-darkgrey">
        <div className="py-12 lg:py-16">
          <div className="text-center">
            <Heading size="h2" className="text-white">
              {blok.title}
            </Heading>
          </div>
          <div className="flex flex-row flex-wrap lg:flex-nowrap max-w-7xl mx-auto relative">
            <div className="flex md:flex-row flex-col w-full px-6 py-4">
              {blok.stats.map((item, index) => {
                return <Stat blok={item} key={index} colour={blok.colour} />;
              })}
            </div>
          </div>
          <div className="text-center">
            <Button
              className="bg-red hover:bg-darkred mt-4"
              target={blok.button_target.cached_url}
            >
              {blok.button_label}
            </Button>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default SimpleOnBrand;
